// COP — React entry point. Mounts the shell; the render loop is imperative.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { loadRenderTuning } from "./host/renderTuning.ts";
import { applyTheme } from "./host/theme.ts";
import "./style.css";

// THEME AT BOOT: applyTheme(COP_THEME) used to run only inside startCop (post-login),
// so the ENTRANCE screens (splash/login) rendered on CSS fallbacks instead of the live
// INTEL_SKIN tokens. Apply once here — idempotent CSS-var setting on :root — so the
// tokens are live pre-login; startCop's own call re-applies harmlessly. The entrance
// CSS keeps its var(--token, fallback) discipline regardless (DDIL).
applyTheme();

// Operator render-tuning config (render-tuning.json — edit + reload, no rebuild). Fire-and-forget:
// the render path live-reads the tuning object, so values landing after first paint apply on the
// next rebuild; any load failure leaves the compiled defaults in effect.
void loadRenderTuning();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("COP: #root element not found");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
